import React, { FC, useState } from 'react';
import {
  Card,
  CardContent,
  Box,
  IconButton,
  Tooltip,
  Backdrop
} from '@material-ui/core';
import { DragAndDropImgUpload } from 'src/components';
import { convertImageFileToBase64 } from 'src/utils';
import useResolution from 'src/hooks/useResolution';
import { FormikProps } from 'formik';
import { CreateChequePayload } from 'src/redux/slices/cheque-management/types';
import DeleteIcon from '@material-ui/icons/Delete';
import CloseIcon from '@material-ui/icons/Close';

interface Props {
  formikRef: FormikProps<CreateChequePayload>;
  isCreatePage?: boolean;
}

const component: FC<Props> = ({ formikRef, isCreatePage }) => {
  const { isMobile } = useResolution();
  const [openPreview, setOpenPreview] = useState(false);

  const chequeImage = formikRef?.values?.cheque_img_url;

  const onChangeBanner = async (img: File[]) => {
    if (img && img.length > 0) {
      const firstFile = img[0];
      const result = await convertImageFileToBase64(firstFile);
      if (typeof result === 'string') {
        formikRef.setFieldValue('cheque_img_url', result);
      } else {
        console.error('Base64 conversion did not return a string:', result);
      }
    }
  };

  const onDelete = () => {
    formikRef.setFieldValue('cheque_img_url', '');
  };

  return (
    <>
      <Card style={{ marginTop: '1em' }}>
        <CardContent>
          {chequeImage && (
            <Box
              sx={{
                padding: '1rem',
                display: 'flex',
                justifyContent: 'center',
                p: '1rem'
              }}
            >
              <img
                alt="Cheque Preview"
                src={chequeImage}
                style={{
                  width: 900,
                  height: isMobile ? 100 : 300,
                  objectFit: 'contain',
                  cursor: 'pointer'
                }}
                onClick={() => setOpenPreview(true)} // open backdrop on click
              />
              <Tooltip title="Remove current image" id="delete-image-button">
                <Box style={{ position: 'absolute', right: 50, zIndex: 99 }}>
                  <IconButton
                    onClick={onDelete}
                    style={{
                      padding: 3,
                      cursor: 'pointer'
                    }}
                  >
                    <DeleteIcon fontSize="medium" color="secondary" />
                  </IconButton>
                </Box>
              </Tooltip>
            </Box>
          )}

          {isCreatePage || chequeImage ? null : (
            <DragAndDropImgUpload
              title="Upload Cheque/Bank Transfer Image"
              onImageSelected={onChangeBanner}
              disablePasteFunc={true}
            />
          )}
        </CardContent>
      </Card>

      {/* Backdrop for Fullscreen Preview */}
      <Backdrop
        open={openPreview}
        style={{
          zIndex: 1300, // above dialogs
          color: '#fff',
          flexDirection: 'column'
        }}
        onClick={() => setOpenPreview(false)}
      >
        <IconButton
          style={{
            alignSelf: 'flex-end',
            color: 'white',
            position: 'absolute',
            top: 20,
            right: 20
          }}
          onClick={(e) => {
            e.stopPropagation();
            setOpenPreview(false);
          }}
        >
          <CloseIcon fontSize="large" />
        </IconButton>
        <img
          src={chequeImage}
          alt="Cheque Full Preview"
          onClick={(e) => e.stopPropagation()}
          style={{
            maxWidth: '90%',
            maxHeight: '90%',
            objectFit: 'contain'
          }}
        />
      </Backdrop>
    </>
  );
};

export const ChequeImageComponent = React.memo(component);
